import React from 'react';
import styles from './FavoriteWordsView.module.css';
import { BookIcon } from '../../components/Icons';

const FavoriteWordsView = ({ groups, bookMetadata, onOpenBookWords }) => {
  if (!groups.length) {
    return (
      <div className={styles.noHistory}>
        <div className={styles.noHistoryIcon}><BookIcon size={48} /></div>
        <h3>还没有收藏的单词</h3>
        <p>在阅读时点击单词即可查看释义并收藏</p>
      </div>
    );
  }

  return (
    <div className={styles.wordsSectionWrapper}>
      {groups.map((bookGroup) => {
        const bookMeta = bookMetadata[String(bookGroup.bookId)] || {};
        const bookTitle = bookMeta.title || bookGroup.bookTitle || '未命名书籍';
        const coverUrl = bookMeta.cover_image_url || '';

        return (
          <button
            key={bookGroup.key}
            type="button"
            className={styles.wordsCard}
            onClick={() => onOpenBookWords(bookGroup)}
            aria-label={`查看${bookTitle}的收藏单词`}
          >
            <div className={styles.wordsCardCover}>
              {coverUrl ? (
                <img src={coverUrl} alt={bookTitle} className={styles.wordsCardCoverImg} />
              ) : (
                <div className={styles.wordsCardCoverPlaceholder}>
                  <BookIcon size={20} />
                </div>
              )}
            </div>
            <div className={styles.wordsCardInfo}>
              <div className={styles.wordsCardTitle}>{bookTitle}</div>
              <span className={styles.wordsCardCount}>
                {bookGroup.itemCount} 个单词
              </span>
            </div>
            <span className={`material-icons-round ${styles.wordsCardArrow}`}>
              arrow_forward
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default FavoriteWordsView;

